import Post from '../post';

/**
 * Create the action
 */

const { thunk, request, success, error } = Post.index((fetch) => {
    return fetch.get('posts');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };